<template>
  <div class="shop-category">
    <div
      class="shop-category-list"
      ref="listRef"
    >
      <FeaturedCategory />
      <div
        class="shop-category-list-item"
        v-for="(item, index) in firstCategoryList"
        :key="index"
        :data-id="item?.categoryId"
        @click="toSearchPage"
      >
        <img
          class="icon"
          :src="item?.icon"
          alt=""
        >
        {{ item?.categoryName }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { useStore } from 'vuex'
import { storeToRefs } from 'pinia'
import { buriedPointUtil } from '@/utils/utils'
import FeaturedCategory from './FeaturedCategory.vue'
import { useLanguageStore } from '@/pinia/language'
import { useCategoryStore } from '@/pinia/category'

const store = useStore()

const language = useLanguageStore()
const categoryStore = useCategoryStore()
const { firstLevel } = storeToRefs(categoryStore)
const firstCategoryList = ref([])
const listRef = ref(null)

watch(
  () => firstLevel.value,
  (data) => {
    if (data?.length) {
      formatData([...data])
    }
  },
  { immediate: true, deep: true }
)

watch(() => language.current, (value) => {
  if (value) {
    categoryStore.loadFirstLevel(value)
  }
}, { immediate: true })

const formatData = (list) => {
  const H5ClickedCategories = JSON.parse(localStorage.getItem('H5ClickedCategories')) || []
  const _temp = []
  if (H5ClickedCategories.length) {
    H5ClickedCategories.forEach(id => {
      const index = list.findIndex(item => item.categoryId === id)
      _temp.push(list[index])
      list.splice(index, 1)
    })
  }

  const fullList = [..._temp, ...list]
  firstCategoryList.value = [...fullList, ...fullList] // 复制一份数据用于无缝滚动
}

const toSearchPage = (e) => {
  const categoryId = e.currentTarget.dataset.id || null
  const item = firstCategoryList.value.find(item => item?.categoryId === categoryId)

  localStorage.setItem('parentCategory', JSON.stringify(item))
  store.commit('h5Module/setCategoryDialogVisible', true)
  buriedPointUtil({ eventId: 'MPWH402', others: { categoryName: item.categoryName, categoryId: item.categoryId } })
}

</script>

<style lang="less">
.shop-category {
  padding: 16px 0;
  background-color: #052784;
  overflow-x: auto;
  min-height: 68px;

  .shop-category-list {
    display: flex;
    flex-wrap: nowrap;
    width: fit-content;
    padding-left: 12px;
    touch-action: pan-x;
    user-select: none;
  }

  .shop-category-list-item {
    position: relative;
    flex-shrink: 0;
    height: 36px;
    padding: 10px 12px 10px 38px;
    border-radius: 20px;
    background-color: #B0C7F5;
    color: #232323;
    font-size: 12px;
    font-family: mon-600;
    margin-right: 12px;
    overflow: hidden;

    &:last-child {
      margin-right: 12px;
    }

    .icon {
      position: absolute;
      top: 0;
      left: 0;
      width: 36px;
    }
  }
}
</style>
